import { render, staticRenderFns } from "./ChoiceWallet.vue?vue&type=template&id=76b043af&scoped=true&"
import script from "./ChoiceWallet.vue?vue&type=script&lang=js&"
export * from "./ChoiceWallet.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceWallet.vue?vue&type=style&index=0&id=76b043af&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b043af",
  null
  
)

export default component.exports